import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

api.interceptors.request.use((c) => {
  const t = localStorage.getItem("bt_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config;
    if (err.response?.status === 401 && cfg && !cfg._retry && !cfg.url.includes("/auth/")) {
      cfg._retry = true;
      try {
        const { data } = await api.post("/auth/refresh");
        localStorage.setItem("bt_token", data.token);
        return api(cfg);
      } catch (e) {
        localStorage.removeItem("bt_token");
      }
    }
    return Promise.reject(err);
  }
);

export const mediaUrl = (u) => {
  if (!u) return "";
  return u.startsWith("/api/") ? `${BACKEND}${u}` : u;
};
export const isExternal = (u) => /^https?:\/\//.test(u || "");

export function formatErr(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export function localDay(d = new Date()) {
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

export const TYPE_META = {
  parent_child: "Parent & Child Affirmation",
  solo: "Solo Affirmation",
  prompt: "Conversation Prompts",
  article: "Article",
  exercise: "Exercise",
  breathwork: "Breathwork",
  meditation: "Meditation",
  video: "Video Lesson",
  audio: "Audio",
  download: "Download",
};

export const formatPrice = (m) => {
  try {
    return new Intl.NumberFormat(undefined, { style: "currency", currency: (m.currency || "gbp").toUpperCase() }).format(m.price || 0);
  } catch (e) {
    return `${m.price}`;
  }
};
